export const prebuiltEcms = {
    ceilingWithAttic: {
        ["upgradePre-2024120600000001-0"]: {
            label: "R40 Eff. (New Const.)",
            packageValues: {
                label: { ceilingWithAttic: "R40 Eff. (New Const.)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                upgradeProcess: "codeReplace",
                fields: {
                    ceilingInsType: {
                        codeRef: "Ceiling-S-2231490000",
                        codeLabel: "2231490000",
                    },
                    ceilingInsType_nomRVal: 7.04,
                    ceilingInsType_effRVal: 7.04,
                },
                codes: {
                    "Ceiling-S-2231490000": {
                        componentType: "Ceiling",
                        codeRef: "Ceiling-S-2231490000",
                        codeType: "Standard",
                        label: "2231490000",
                        value: "2231490000",
                        description: "Attic eff. R40",
                        nominalRValue: 7.04,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 45,
                                value: "3",
                            },
                            spacing: {
                                id: 4,
                                value: "1",
                            },
                            framing: {
                                id: null,
                            },
                            insulationLayer1: {
                                id: 7,
                                value: "4",
                            },
                            insulationLayer2: {
                                id: 26,
                                value: "9",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 24.54, //LEEP 2.28/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000001-1"]: {
            label: "R50 Eff. (New Const.)",
            packageValues: {
                label: { ceilingWithAttic: "R50 Eff. (New Const.)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                upgradeProcess: "codeReplace",
                fields: {
                    ceilingInsType: {
                        codeRef: "Ceiling-S-2221a90000",
                        codeLabel: "2221a90000",
                    },
                    ceilingInsType_nomRVal: 8.81,
                    ceilingInsType_effRVal: 8.81,
                },
                codes: {
                    "Ceiling-S-2221a90000": {
                        componentType: "Ceiling",
                        codeRef: "Ceiling-S-2221a90000",
                        codeType: "Standard",
                        label: "2221a90000",
                        value: "2221a90000",
                        description: "Attic eff. R50",
                        nominalRValue: 9.86,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 44,
                                value: "2",
                            },
                            spacing: {
                                id: 4,
                                value: "1",
                            },
                            framing: {
                                id: null,
                            },
                            insulationLayer1: {
                                id: 9,
                                value: "a",
                            },
                            insulationLayer2: {
                                id: 26,
                                value: "9",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 28.31, //LEEP 2.63/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000001-2"]: {
            label: "R60 Eff. (New Const.)",
            packageValues: {
                label: { ceilingWithAttic: "R60 Eff. (New Const.)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                upgradeProcess: "codeReplace",
                fields: {
                    ceilingInsType: {
                        codeRef: "Ceiling-S-2231c90000",
                        codeLabel: "2231c90000",
                    },
                    ceilingInsType_nomRVal: 10.57,
                    ceilingInsType_effRVal: 10.57,
                },
                codes: {
                    "Ceiling-S-2231c90000": {
                        componentType: "Ceiling",
                        codeRef: "Ceiling-S-2231c90000",
                        codeType: "Standard",
                        label: "2231c90000",
                        value: "2231c90000",
                        description: "Attic eff. R60",
                        nominalRValue: 10.57,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 45,
                                value: "3",
                            },
                            spacing: {
                                id: 4,
                                value: "1",
                            },
                            framing: {
                                id: null,
                            },
                            insulationLayer1: {
                                id: 12,
                                value: "c",
                            },
                            insulationLayer2: {
                                id: 26,
                                value: "9",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 33.37, //LEEP 3.1/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000001-3"]: {
            label: "R70 Eff. (New Const.)",
            packageValues: {
                label: { ceilingWithAttic: "R70 Eff. (New Const.)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                upgradeProcess: "codeReplace",
                fields: {
                    ceilingInsType: {
                        codeRef: "Ceiling-S-2243J90000",
                        codeLabel: "2243J90000",
                    },
                    ceilingInsType_nomRVal: 12.33,
                    ceilingInsType_effRVal: 12.33,
                },
                codes: {
                    "Ceiling-S-2243J90000": {
                        componentType: "Ceiling",
                        codeRef: "Ceiling-S-2243J90000",
                        codeType: "Standard",
                        label: "2243J90000",
                        value: "2243J90000",
                        description: "Attic eff. R70",
                        nominalRValue: 12.33,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 46,
                                value: "4",
                            },
                            spacing: {
                                id: 6,
                                value: "3",
                            },
                            framing: {
                                id: null,
                            },
                            insulationLayer1: {
                                id: 13,
                                value: "J",
                            },
                            insulationLayer2: {
                                id: 26,
                                value: "9",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 41.87, //LEEP $3.89	/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000001-4"]: {
            label: "R80 Eff. (New Const.)",
            packageValues: {
                label: { ceilingWithAttic: "R80 Eff. (New Const.)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                fields: {
                    ceilingInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    ceilingInsType_nomRVal: 14.09,
                    ceilingInsType_effRVal: 14.09,
                },
                codes: {},
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 49.84, //LEEP 4.63/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-2024120600000001-5"]: {
            label: "Add R20 Blown-In Insulation (Retrofit)",
            packageValues: {
                label: { ceilingWithAttic: "Add R20 Blown-In Insulation (Retrofit)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                fields: {
                    ceilingInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    ceilingInsType_nomRVal: parseFloat((20 / 5.678).toFixed(2)),
                    ceilingInsType_effRVal: parseFloat((20 / 5.678).toFixed(2)),
                    addUserSpecifiedRVal: true,
                },
                codes: {},
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 17.22, //LEEP 1.6/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000001-6"]: {
            label: "Add R30 Blown-In Insulation (Retrofit)",
            packageValues: {
                label: { ceilingWithAttic: "Add R30 Blown-In Insulation (Retrofit)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                fields: {
                    ceilingInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    ceilingInsType_nomRVal: parseFloat((30 / 5.678).toFixed(2)),
                    ceilingInsType_effRVal: parseFloat((30 / 5.678).toFixed(2)),
                    addUserSpecifiedRVal: true,
                },
                codes: {},
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 21.74, //LEEP 2.02/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000001-7"]: {
            label: "Add R40 Blown-In Insulation (Retrofit)",
            packageValues: {
                label: { ceilingWithAttic: "Add R40 Blown-In Insulation (Retrofit)" },
                upgradeType: "ceiling",
                upgradeSubType: "ceilingWithAttic",
                fields: {
                    ceilingInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    ceilingInsType_nomRVal: parseFloat((40 / 5.678).toFixed(2)),
                    ceilingInsType_effRVal: parseFloat((40 / 5.678).toFixed(2)),
                    addUserSpecifiedRVal: true,
                },
                codes: {},
                cost: {
                    ceilingWithAttic: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 31.11, //LEEP 2.89/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    cathedral: {},
    wall: {
        ["upgradePre-2024120600000003-0"]: {
            label: "R17 Eff. (New Const.)",
            packageValues: {
                label: { wall: "R17 Eff. (New Const.)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((17 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((17 / 5.678).toFixed(2)),
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 72.33, //LEEP 6.72/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-1"]: {
            label: "R21 Eff. (New Const.)",
            packageValues: {
                label: { wall: "R21 Eff. (New Const.)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((21 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((21 / 5.678).toFixed(2)),
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 98.92, //LEEP 9.19/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-2"]: {
            label: "R23.5 Eff. (New Const.)",
            packageValues: {
                label: { wall: "R23.5 Eff. (New Const.)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((23.5 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((23.5 / 5.678).toFixed(2)),
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 107.96, //LEEP 10.03/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-3"]: {
            label: "R26 Eff. (New Const.)",
            packageValues: {
                label: { wall: "R26 Eff. (New Const.)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((26 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((26 / 5.678).toFixed(2)),
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 115.28, //LEEP 10.71/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-4"]: {
            label: "R30 Eff. (New Const.)",
            packageValues: {
                label: { wall: "R30 Eff. (New Const.)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((30 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((30 / 5.678).toFixed(2)),
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 146.17, //LEEP 13.58/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-5"]: {
            label: "R40 Eff. (New Const.)",
            packageValues: {
                label: { wall: "R40 Eff. (New Const.)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((40 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((40 / 5.678).toFixed(2)),
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 158.23, //LEEP 14.7/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-2024120600000003-6"]: {
            label: "Add R10 Eff. (Retrofit)",
            packageValues: {
                label: { wall: "Add R10 Eff. (Retrofit)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((10 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((10 / 5.678).toFixed(2)),
                    addUserSpecifiedRVal: true,
                    lintelInsType: {},
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 321.41, //LEEP 29.86/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-7"]: {
            label: "Add R20 Eff. (Retrofit)",
            packageValues: {
                label: { wall: "Add R20 Eff. (Retrofit)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((20 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((20 / 5.678).toFixed(2)),
                    addUserSpecifiedRVal: true,
                    lintelInsType: {},
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 390.51, //LEEP 36.28/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-8"]: {
            label: "Add R30 Eff. (Retrofit)",
            packageValues: {
                label: { wall: "Add R30 Eff. (Retrofit)" },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((30 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((30 / 5.678).toFixed(2)),
                    addUserSpecifiedRVal: true,
                    lintelInsType: {},
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 459.62, //LEEP 42.7/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-2024120600000003-9"]: {
            label: 'Fill Empty 4" Wall Cavities with Batt/Blown (R-7.5 Eff.) (Retrofit)',
            packageValues: {
                label: { wall: 'Fill Empty 4" Wall Cavities with Batt/Blown (R-7.5 Eff.) (Retrofit)' },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((7.5 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((7.5 / 5.678).toFixed(2)),
                    lintelInsType: {},
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 73.52, //LEEP 6.83/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-10"]: {
            label: 'Fill Empty 4" Wall Cavities with Batt/Blown+ R-10 Exterior (R-17.5 Eff.) (Retrofit)',
            packageValues: {
                label: {
                    wall: 'Fill Empty 4" Wall Cavities with Batt/Blown+ R-10 Exterior (R-17.5 Eff.) (Retrofit)',
                },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((17.5 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((17.5 / 5.678).toFixed(2)),
                    lintelInsType: {},
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 394.93, //LEEP 36.69/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-11"]: {
            label: 'Fill Empty 4" Wall Cavities with Batt/Blown+ R-20 Exterior (R-27.5 Eff.) (Retrofit)',
            packageValues: {
                label: {
                    wall: 'Fill Empty 4" Wall Cavities with Batt/Blown+ R-20 Exterior (R-27.5 Eff.) (Retrofit)',
                },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((27.5 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((27.5 / 5.678).toFixed(2)),
                    lintelInsType: {},
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 464.03, //LEEP 43.11/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000003-12"]: {
            label: 'Fill Empty 4" Wall Cavities with Batt/Blown+ R-30 Exterior (R-37.5 Eff.) (Retrofit)',
            packageValues: {
                label: {
                    wall: 'Fill Empty 4" Wall Cavities with Batt/Blown+ R-30 Exterior (R-37.5 Eff.) (Retrofit)',
                },
                upgradeType: "wall",
                upgradeSubType: "wall",
                fields: {
                    wallInsType: { codeRef: "UserSpecified", codeLabel: "User Specified" },
                    wallInsType_nomRVal: parseFloat((37.5 / 5.678).toFixed(2)),
                    wallInsType_effRVal: parseFloat((37.5 / 5.678).toFixed(2)),
                    lintelInsType: {},
                },
                floorHeaderAddedRSI: 0,
                codes: {},
                cost: {
                    wall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 533.14, //LEEP 49.53/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    expFloor: {},
    floorHeader: {},
    basementWall: {
        ["upgradePre-2024120600000006-0"]: {
            label: "R15 Eff. (New Const.)",
            packageValues: {
                label: { basementWall: "R15 Eff. (New Const.)" },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: 0 },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: parseFloat((15 / 5.678).toFixed(2)),
                        intAddedInsType_nomRVal: parseFloat((15 / 5.678).toFixed(2)),
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: parseFloat((15 / 5.678).toFixed(2)),
                                nominalRsi: parseFloat((15 / 5.678).toFixed(2)),
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 153.49, //LEEP 14.26/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000006-1"]: {
            label: "R18.5 Eff. (New Const.)",
            packageValues: {
                label: { basementWall: "R18.5 Eff. (New Const.)" },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: 0 },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: parseFloat((18.5 / 5.678).toFixed(2)),
                        intAddedInsType_nomRVal: parseFloat((18.5 / 5.678).toFixed(2)),
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: parseFloat((18.5 / 5.678).toFixed(2)),
                                nominalRsi: parseFloat((18.5 / 5.678).toFixed(2)),
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 161.46, //LEEP 15/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000006-2"]: {
            label: "R21 Eff. (New Const.)",
            packageValues: {
                label: { basementWall: "R21 Eff. (New Const.)" },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: 0 },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: parseFloat((21 / 5.678).toFixed(2)),
                        intAddedInsType_nomRVal: parseFloat((21 / 5.678).toFixed(2)),
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: parseFloat((21 / 5.678).toFixed(2)),
                                nominalRsi: parseFloat((21 / 5.678).toFixed(2)),
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 188.05, //LEEP 17.47/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000006-3"]: {
            label: "R28 Eff. (New Const.)",
            packageValues: {
                label: { basementWall: "R28 Eff. (New Const.)" },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: 0 },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: parseFloat((28 / 5.678).toFixed(2)),
                        intAddedInsType_nomRVal: parseFloat((28 / 5.678).toFixed(2)),
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: parseFloat((28 / 5.678).toFixed(2)),
                                nominalRsi: parseFloat((28 / 5.678).toFixed(2)),
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 208.28, //LEEP 19.35/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-2024120600000006-4"]: {
            label: "Replace Interior Insulation w/ Framed and Insulated 2x4 Stud Wall (R17 Effective) (Retrofit)",
            packageValues: {
                label: {
                    basementWall:
                        "Replace Interior Insulation w/ Framed and Insulated 2x4 Stud Wall (R17 Effective) (Retrofit)",
                },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: 0 },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: parseFloat((10 / 5.678).toFixed(2)),
                        intAddedInsType_nomRVal: parseFloat((10 / 5.678).toFixed(2)),
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: parseFloat((10 / 5.678).toFixed(2)),
                                nominalRsi: parseFloat((10 / 5.678).toFixed(2)),
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 202.36, //LEEP 18.8/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000006-5"]: {
            label: "Replace Interior Insulation w/ Framed and Insulated 2x6 Stud Wall (R17 Effective) (Retrofit)",
            packageValues: {
                label: {
                    basementWall:
                        "Replace Interior Insulation w/ Framed and Insulated 2x6 Stud Wall (R17 Effective) (Retrofit)",
                },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: 0 },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: parseFloat((17 / 5.678).toFixed(2)),
                        intAddedInsType_nomRVal: parseFloat((17 / 5.678).toFixed(2)),
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: parseFloat((17 / 5.678).toFixed(2)),
                                nominalRsi: parseFloat((17 / 5.678).toFixed(2)),
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 213.45, //LEEP 19.83/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000006-6"]: {
            label: "Replace Existing Exterior Insulation with R20 Rigid Insulation (Retrofit)",
            packageValues: {
                label: { basementWall: "Replace Existing Exterior Insulation with R20 Rigid Insulation (Retrofit)" },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: parseFloat((20 / 5.678).toFixed(2)) },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: 0,
                        intAddedInsType_nomRVal: 0,
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: 0,
                                nominalRsi: 0,
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 296.12, //LEEP 27.51/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000006-7"]: {
            label: "Insulated 2x4 Stud Wall and R20 Exterior Insulation (R30 Effective) (Retrofit)",
            packageValues: {
                label: {
                    basementWall: "Insulated 2x4 Stud Wall and R20 Exterior Insulation (R30 Effective) (Retrofit)",
                },
                upgradeType: "basement",
                upgradeSubType: "basementWall",
                upgradeProcess: "UserSpecified",
                fields: {
                    wall: {
                        extAddedInsType: { id: 10, value: parseFloat((20 / 5.678).toFixed(2)) },
                        extAddedInsType_composite: {},
                        intAddedInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        intAddedInsType_effRVal: parseFloat((10 / 5.678).toFixed(2)),
                        intAddedInsType_nomRVal: parseFloat((10 / 5.678).toFixed(2)),
                        intAddedInsType_composite: {
                            section0: {
                                section: 1,
                                percentage: 100,
                                rsi: parseFloat((10 / 5.678).toFixed(2)),
                                nominalRsi: parseFloat((10 / 5.678).toFixed(2)),
                            },
                        },
                    },
                },
                codes: {},
                cost: {
                    basementWall: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostIntWalls",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 480.29, //LEEP 44.62/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    basementSlab: {
        ["upgradePre-2025112000000007-0"]: {
            label: "Uninsulated",
            packageValues: {
                label: { basementSlab: "Uninsulated" },
                upgradeType: "basement",
                upgradeSubType: "basementSlab",
                upgradeProcess: "UserSpecified",
                fields: {
                    floor: {
                        slabInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        slabInsType_nomRVal: 0,
                        slabInsType_effRVal: 0,
                        floorsAboveInsType: {
                            codeRef: "FloorsAbove-S-4231000660",
                            codeLabel: "4231000660",
                        },
                        floorsAboveInsType_nomRVal: 0.7,
                        floorsAboveInsType_effRVal: 0.7,
                    },
                },
                codes: {
                    "FloorsAbove-S-4231000660": {
                        codeRef: "FloorsAbove-S-4231000660",
                        label: "4231000660",
                        value: "4231000660",
                        description: "4231000660",
                        nominalRValue: 0.7,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 45,
                                value: "3",
                            },
                            spacing: {
                                id: 4,
                                value: "1",
                            },
                            framing: {
                                id: null,
                                value: null,
                            },
                            insulationLayer1: {
                                id: 0,
                                value: "0",
                            },
                            insulationLayer2: {
                                id: 0,
                                value: "0",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                            sheathing: {
                                id: 6,
                                value: "6",
                            },
                            exterior: {
                                id: 6,
                                value: "6",
                            },
                            dropFraming: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    basementSlab: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostSlab",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 0, //LEEP $0/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112000000007-1"]: {
            label: "R6 Eff. Sub-slab Insulation (New Const.)",
            packageValues: {
                label: { basementSlab: "R6 Eff. Sub-slab Insulation (New Const.)" },
                upgradeType: "basement",
                upgradeSubType: "basementSlab",
                upgradeProcess: "UserSpecified",
                fields: {
                    floor: {
                        slabInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        slabInsType_nomRVal: parseFloat((6 / 5.678).toFixed(2)),
                        slabInsType_effRVal: parseFloat((6 / 5.678).toFixed(2)),
                        floorsAboveInsType: {
                            codeRef: "FloorsAbove-S-4231000660",
                            codeLabel: "4231000660",
                        },
                        floorsAboveInsType_nomRVal: 0.7,
                        floorsAboveInsType_effRVal: 0.7,
                    },
                },
                codes: {
                    "FloorsAbove-S-4231000660": {
                        codeRef: "FloorsAbove-S-4231000660",
                        label: "4231000660",
                        value: "4231000660",
                        description: "4231000660",
                        nominalRValue: 0.7,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 45,
                                value: "3",
                            },
                            spacing: {
                                id: 4,
                                value: "1",
                            },
                            framing: {
                                id: null,
                                value: null,
                            },
                            insulationLayer1: {
                                id: 0,
                                value: "0",
                            },
                            insulationLayer2: {
                                id: 0,
                                value: "0",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                            sheathing: {
                                id: 6,
                                value: "6",
                            },
                            exterior: {
                                id: 6,
                                value: "6",
                            },
                            dropFraming: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    basementSlab: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostSlab",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 22.07, //LEEP 2.05/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112000000007-2"]: {
            label: "R10 Eff. Sub-slab Insulation (New Const.)",
            packageValues: {
                label: { basementSlab: "R10 Eff. Sub-slab Insulation (New Const.)" },
                upgradeType: "basement",
                upgradeSubType: "basementSlab",
                upgradeProcess: "UserSpecified",
                fields: {
                    floor: {
                        slabInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        slabInsType_nomRVal: 1.76,
                        slabInsType_effRVal: 1.76,
                        floorsAboveInsType: {
                            codeRef: "FloorsAbove-S-4231000660",
                            codeLabel: "4231000660",
                        },
                        floorsAboveInsType_nomRVal: 0.7,
                        floorsAboveInsType_effRVal: 0.7,
                    },
                },
                codes: {
                    "FloorsAbove-S-4231000660": {
                        codeRef: "FloorsAbove-S-4231000660",
                        label: "4231000660",
                        value: "4231000660",
                        description: "4231000660",
                        nominalRValue: 0.7,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 45,
                                value: "3",
                            },
                            spacing: {
                                id: 4,
                                value: "1",
                            },
                            framing: {
                                id: null,
                                value: null,
                            },
                            insulationLayer1: {
                                id: 0,
                                value: "0",
                            },
                            insulationLayer2: {
                                id: 0,
                                value: "0",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                            sheathing: {
                                id: 6,
                                value: "6",
                            },
                            exterior: {
                                id: 6,
                                value: "6",
                            },
                            dropFraming: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    basementSlab: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostSlab",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 31.86, //LEEP 2.96/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112000000007-3"]: {
            label: "R20 Eff. Sub-slab Insulation (New Const.)",
            packageValues: {
                label: { basementSlab: "R20 Eff. Sub-slab Insulation (New Const.)" },
                upgradeType: "basement",
                upgradeSubType: "basementSlab",
                upgradeProcess: "UserSpecified",
                fields: {
                    floor: {
                        slabInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        slabInsType_nomRVal: parseFloat((20 / 5.678).toFixed(2)),
                        slabInsType_effRVal: parseFloat((20 / 5.678).toFixed(2)),
                        floorsAboveInsType: {
                            codeRef: "FloorsAbove-S-4231000660",
                            codeLabel: "4231000660",
                        },
                        floorsAboveInsType_nomRVal: 0.7,
                        floorsAboveInsType_effRVal: 0.7,
                    },
                },
                codes: {
                    "FloorsAbove-S-4231000660": {
                        codeRef: "FloorsAbove-S-4231000660",
                        label: "4231000660",
                        value: "4231000660",
                        description: "4231000660",
                        nominalRValue: 0.7,
                        layers: {
                            structureType: {
                                id: 0,
                                value: "2",
                            },
                            componentTypeSize: {
                                id: 45,
                                value: "3",
                            },
                            spacing: {
                                id: 4,
                                value: "1",
                            },
                            framing: {
                                id: null,
                                value: null,
                            },
                            insulationLayer1: {
                                id: 0,
                                value: "0",
                            },
                            insulationLayer2: {
                                id: 0,
                                value: "0",
                            },
                            interior: {
                                id: 0,
                                value: "0",
                            },
                            sheathing: {
                                id: 6,
                                value: "6",
                            },
                            exterior: {
                                id: 6,
                                value: "6",
                            },
                            dropFraming: {
                                id: 0,
                                value: "0",
                            },
                        },
                    },
                },
                cost: {
                    basementSlab: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostSlab",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 53.93, //LEEP 5.01/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    crawlspace: {},
    slab: {
        ["upgradePre-2025112000000008-0"]: {
            label: "R10 Eff. (New Const.)",
            packageValues: {
                label: { slab: "R10 Eff. (New Const.)" },
                upgradeType: "slab",
                upgradeSubType: "slab",
                upgradeProcess: "UserSpecified",
                fields: {
                    floor: {
                        slabInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        slabInsType_nomRVal: parseFloat((10 / 5.678).toFixed(2)),
                        slabInsType_effRVal: parseFloat((10 / 5.678).toFixed(2)),
                    },
                },
                codes: {},
                cost: {
                    slab: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostSlab",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 29.17, //LEEP 2.71/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112000000008-1"]: {
            label: "R20 Eff. (New Const.)",
            packageValues: {
                label: { slab: "R20 Eff. (New Const.)" },
                upgradeType: "slab",
                upgradeSubType: "slab",
                upgradeProcess: "UserSpecified",
                fields: {
                    floor: {
                        slabInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        slabInsType_nomRVal: parseFloat((20 / 5.678).toFixed(2)),
                        slabInsType_effRVal: parseFloat((20 / 5.678).toFixed(2)),
                    },
                },
                codes: {},
                cost: {
                    slab: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostSlab",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 53.28, //LEEP 4.95/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112000000008-2"]: {
            label: "R30 Eff. (New Const.)",
            packageValues: {
                label: { slab: "R30 Eff. (New Const.)" },
                upgradeType: "slab",
                upgradeSubType: "slab",
                upgradeProcess: "UserSpecified",
                fields: {
                    floor: {
                        slabInsType: {
                            codeRef: "UserSpecified",
                            codeLabel: "User Specified",
                        },
                        slabInsType_nomRVal: parseFloat((30 / 5.678).toFixed(2)),
                        slabInsType_effRVal: parseFloat((30 / 5.678).toFixed(2)),
                    },
                },
                codes: {},
                cost: {
                    slab: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostSlab",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 77.5, //LEEP 7.2/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    window: {
        ["upgradePre-2024120600000010-0"]: {
            label: "U-1.6 SHGC-0.3, Double, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-1.6 SHGC-0.3, Double, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000005",
                        codeLabel: "Double U-1.6 SHGC-0.3",
                    },
                    windowType_nomRVal: 0.625,
                    windowType_effRVal: 0.625,
                    shgc: 0.3,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000005": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000005",
                        codeType: "UserDefined",
                        label: "Double U-1.6 SHGC-0.3",
                        value: "",
                        description: "U-1.6 SHGC-0.3",
                        nominalRValue: 0.625,
                        er: 34,
                        shgc: 0.3,
                        layers: {
                            window: {
                                window2023083112000005: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.6 },
                                    shgc: 0.3,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 324.85, //LEEP 30.18/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-1"]: {
            label: "U-1.6 SHGC-0.2, Double, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-1.6 SHGC-0.2, Double, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000006",
                        codeLabel: "Double U-1.6 SHGC-0.2",
                    },
                    windowType_nomRVal: 0.625,
                    windowType_effRVal: 0.625,
                    shgc: 0.2,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000006": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000006",
                        codeType: "UserDefined",
                        label: "Double U-1.6 SHGC-0.2",
                        value: "",
                        description: "Double U-1.6 SHGC-0.2",
                        nominalRValue: 0.625,
                        er: 34,
                        shgc: 0.2,
                        layers: {
                            window: {
                                window2023083112000006: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.6 },
                                    shgc: 0.2,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 351.01, //LEEP 32.61/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-2"]: {
            label: "U-1.2 SHGC-0.3, Double, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-1.2 SHGC-0.3, Double, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2024052212000005",
                        codeLabel: "Double U-1.2 SHGC-0.3",
                    },
                    windowType_nomRVal: 0.833,
                    windowType_effRVal: 0.833,
                    shgc: 0.3,
                    er: 34,
                },
                codes: {
                    "Window-U-2024052212000005": {
                        componentType: "Window",
                        codeRef: "Window-U-2024052212000005",
                        codeType: "UserDefined",
                        label: "Double U-1.2 SHGC-0.3",
                        value: "",
                        description: "Double U-1.2 SHGC-0.3",
                        nominalRValue: 0.833,
                        er: 34,
                        shgc: 0.3,
                        layers: {
                            window: {
                                window2024052212000005: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.2 },
                                    shgc: 0.3,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 364.57, //LEEP 33.87/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-3"]: {
            label: "U-1.2 SHGC-0.2, Double, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-1.2 SHGC-0.2, Double, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2024052212000006",
                        codeLabel: "Double U-1.2 SHGC-0.2",
                    },
                    windowType_nomRVal: 0.833,
                    windowType_effRVal: 0.833,
                    shgc: 0.2,
                    er: 34,
                },
                codes: {
                    "Window-U-2024052212000006": {
                        componentType: "Window",
                        codeRef: "Window-U-2024052212000006",
                        codeType: "UserDefined",
                        label: "Double U-1.2 SHGC-0.2",
                        value: "",
                        description: "Double U-1.2 SHGC-0.2",
                        nominalRValue: 0.833,
                        er: 34,
                        shgc: 0.2,
                        layers: {
                            window: {
                                window2024052212000006: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.2 },
                                    shgc: 0.2,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 400.53, //LEEP 37.21/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-4"]: {
            label: "U-1.05 SHGC-0.3, Triple, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-1.05 SHGC-0.3, Triple, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000002",
                        codeLabel: "Triple U-1.05 SHGC-0.3",
                    },
                    windowType_nomRVal: 0.95,
                    windowType_effRVal: 0.95,
                    shgc: 0.3,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000002": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000002",
                        codeType: "UserDefined",
                        label: "Triple U-1.05 SHGC-0.3",
                        value: "",
                        description: "Triple U-1.05 SHGC-0.3",
                        nominalRValue: 0.95,
                        er: 34,
                        shgc: 0.3,
                        layers: {
                            window: {
                                window2023083112000002: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.05 },
                                    shgc: 0.3,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 465.65, //LEEP 43.26/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-5"]: {
            label: "U-1.05 SHGC-0.2, Triple, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-1.05 SHGC-0.2, Triple, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000001",
                        codeLabel: "Triple U-1.05 SHGC-0.2",
                    },
                    windowType_nomRVal: 0.95,
                    windowType_effRVal: 0.95,
                    shgc: 0.2,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000001": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000001",
                        codeType: "UserDefined",
                        label: "Triple U-1.05 SHGC-0.2",
                        value: "",
                        description: "Triple U-1.05 SHGC-0.2",
                        nominalRValue: 0.95,
                        er: 34,
                        shgc: 0.2,
                        layers: {
                            window: {
                                window2023083112000001: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.05 },
                                    shgc: 0.2,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 501.6, //LEEP 46.6/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-6"]: {
            label: "U-0.80 SHGC-0.3, Triple, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-0.80 SHGC-0.3, Triple, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000004",
                        codeLabel: "Triple U-0.80 SHGC-0.3",
                    },
                    windowType_nomRVal: 1.25,
                    windowType_effRVal: 1.25,
                    shgc: 0.3,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000004": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000004",
                        codeType: "UserDefined",
                        label: "Triple U-0.80 SHGC-0.3",
                        value: "",
                        description: "Triple U-0.80 SHGC-0.3",
                        nominalRValue: 1.25,
                        er: 34,
                        shgc: 0.3,
                        layers: {
                            window: {
                                window2023083112000004: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 0.8 },
                                    shgc: 0.3,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 520.65, //LEEP 48.37/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-7"]: {
            label: "U-0.80 SHGC-0.2, Triple, Low-E, Ar (New Const.)",
            packageValues: {
                label: { window: "U-0.80 SHGC-0.2, Triple, Low-E, Ar (New Const.)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000003",
                        codeLabel: "Triple U-0.80 SHGC-0.2",
                    },
                    windowType_nomRVal: 1.25,
                    windowType_effRVal: 1.25,
                    shgc: 0.2,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000003": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000003",
                        codeType: "UserDefined",
                        label: "Triple U-0.80 SHGC-0.2",
                        value: "",
                        description: "Triple U-0.80 SHGC-0.2",
                        nominalRValue: 1.25,
                        er: 34,
                        shgc: 0.2,
                        layers: {
                            window: {
                                window2023083112000003: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 0.8 },
                                    shgc: 0.2,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 566.5, //LEEP 52.63/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-2024120600000010-8"]: {
            label: "U-1.6 SHGC-0.3, Double, Low-E, Ar (Retrofit)",
            packageValues: {
                label: { window: "U-1.6 SHGC-0.3, Double, Low-E, Ar (Retrofit)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000005",
                        codeLabel: "U-1.6 SHGC-0.3",
                    },
                    windowType_nomRVal: 0.625,
                    windowType_effRVal: 0.625,
                    shgc: 0.3,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000005": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000005",
                        codeType: "UserDefined",
                        label: "U-1.6 SHGC-0.3",
                        value: "",
                        description: "U-1.6 SHGC-0.3",
                        nominalRValue: 0.625,
                        er: 34,
                        shgc: 0.3,
                        layers: {
                            window: {
                                window2023083112000005: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.6 },
                                    shgc: 0.3,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 1506.3, //LEEP 139.94/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-9"]: {
            label: "U-1.6 SHGC-0.2, Double, Low-E, Ar (Retrofit)",
            packageValues: {
                label: { window: "U-1.6 SHGC-0.2, Double, Low-E, Ar (Retrofit)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000006",
                        codeLabel: "U-1.6 SHGC-0.2",
                    },
                    windowType_nomRVal: 0.625,
                    windowType_effRVal: 0.625,
                    shgc: 0.2,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000006": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000006",
                        codeType: "UserDefined",
                        label: "U-1.6 SHGC-0.2",
                        value: "",
                        description: "U-1.6 SHGC-0.2",
                        nominalRValue: 0.625,
                        er: 34,
                        shgc: 0.2,
                        layers: {
                            window: {
                                window2023083112000006: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.6 },
                                    shgc: 0.2,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 1530.31, //LEEP 142.17/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-10"]: {
            label: "U-1.05 SHGC-0.3, Triple, Low-E, Ar (Retrofit)",
            packageValues: {
                label: { window: "U-1.05 SHGC-0.3, Triple, Low-E, Ar (Retrofit)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000002",
                        codeLabel: "U-1.05 SHGC-0.3",
                    },
                    windowType_nomRVal: 0.95,
                    windowType_effRVal: 0.95,
                    shgc: 0.3,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000002": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000002",
                        codeType: "UserDefined",
                        label: "U-1.05 SHGC-0.3",
                        value: "",
                        description: "U-1.05 SHGC-0.3",
                        nominalRValue: 0.95,
                        er: 34,
                        shgc: 0.3,
                        layers: {
                            window: {
                                window2023083112000002: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.05 },
                                    shgc: 0.3,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 1705.97, //LEEP 158.49/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-11"]: {
            label: "U-1.05 SHGC-0.2, Triple, Low-E, Ar (Retrofit)",
            packageValues: {
                label: { window: "U-1.05 SHGC-0.2, Triple, Low-E, Ar (Retrofit)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000001",
                        codeLabel: "U-1.05 SHGC-0.2",
                    },
                    windowType_nomRVal: 0.95,
                    windowType_effRVal: 0.95,
                    shgc: 0.2,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000001": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000001",
                        codeType: "UserDefined",
                        label: "U-1.05 SHGC-0.2",
                        value: "",
                        description: "U-1.05 SHGC-0.2",
                        nominalRValue: 0.95,
                        er: 34,
                        shgc: 0.2,
                        layers: {
                            window: {
                                window2023083112000001: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 1.05 },
                                    shgc: 0.2,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 1765.93, //LEEP 164.06/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-2024120600000010-12"]: {
            label: "U-0.8 SHGC-0.3, Triple, Low-E, Ar (Retrofit)",
            packageValues: {
                label: { window: "U-0.8 SHGC-0.3, Triple, Low-E, Ar (Retrofit)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000004",
                        codeLabel: "U-0.8 SHGC-0.3",
                    },
                    windowType_nomRVal: 1.25,
                    windowType_effRVal: 1.25,
                    shgc: 0.3,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000004": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000004",
                        codeType: "UserDefined",
                        label: "U-0.8 SHGC-0.3",
                        value: "",
                        description: "U-0.8 SHGC-0.3",
                        nominalRValue: 1.25,
                        er: 34,
                        shgc: 0.3,
                        layers: {
                            window: {
                                window2023083112000004: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 0.8 },
                                    shgc: 0.3,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 1797.79, //LEEP 167.02/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024120600000010-13"]: {
            label: "U-0.8 SHGC-0.2, Triple, Low-E, Ar (Retrofit)",
            packageValues: {
                label: { window: "U-0.8 SHGC-0.2, Triple, Low-E, Ar (Retrofit)" },
                upgradeType: "window",
                upgradeSubType: "window",
                upgradeProcess: "codeReplace",
                fields: {
                    windowType: {
                        codeRef: "Window-U-2023083112000003",
                        codeLabel: "U-0.8 SHGC-0.2",
                    },
                    windowType_nomRVal: 1.25,
                    windowType_effRVal: 1.25,
                    shgc: 0.2,
                    er: 34,
                },
                codes: {
                    "Window-U-2023083112000003": {
                        componentType: "Window",
                        codeRef: "Window-U-2023083112000003",
                        codeType: "UserDefined",
                        label: "U-0.8 SHGC-0.2",
                        value: "",
                        description: "U-0.8 SHGC-0.2",
                        nominalRValue: 1.25,
                        er: 34,
                        shgc: 0.2,
                        layers: {
                            window: {
                                window2023083112000003: {
                                    fillGas: { id: 1 },
                                    frameHeight: 0,
                                    glazingType: { id: 3 },
                                    layer: 1,
                                    lowECoating: { id: 1 },
                                    overallThermalResistance: { id: 1, value: 0.8 },
                                    shgc: 0.2,
                                    windowStyle: { id: 2 },
                                },
                            },
                        },
                    },
                },
                cost: {
                    window: {
                        total: 1000,
                        items: {
                            "item-builtin-cost-1": {
                                label: "matCostArea",
                                total: 1000,
                                totalArea: 100,
                                pricePerUnit: 1861.73, //LEEP 172.96/sqft
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    skylights: {},
    door: {},
    airTightness: {
        ["upgradePre-2024112100000013-0"]: {
            label: "25% Reduction (Retrofit)",
            noEdit: true,
            packageValues: {
                label: { airTightness: "25% Reduction (Retrofit)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achPercent",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 0.25, //As the % reduction
                        eqLeakageArea: 0.25,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 9.47, //LEEP 0.88/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024112100000013-1"]: {
            label: "50% Reduction (Retrofit)",
            noEdit: true,
            packageValues: {
                label: { airTightness: "50% Reduction (Retrofit)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achPercent",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 0.5, //As the % reduction
                        eqLeakageArea: 0.5,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 9.47, //LEEP 0.88/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2024112100000013-2"]: {
            label: "75% Reduction (Retrofit)",
            noEdit: true,
            packageValues: {
                label: { airTightness: "75% Reduction (Retrofit)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achPercent",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 0.75, //As the % reduction
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 9.47, //LEEP 0.88/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000113-0"]: {
            label: "3.5 ACH50 (New Const.)",
            packageValues: {
                label: { airTightness: "3.5 ACH50 (New Const.)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 3.5,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 3.98, //LEEP 0.37/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000113-1"]: {
            label: "3.0 ACH50 (New Const.)",
            packageValues: {
                label: { airTightness: "3.0 ACH50 (New Const.)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 3.0,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 3.98, //LEEP 0.37/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000113-2"]: {
            label: "2.5 ACH50 (New Const.)",
            packageValues: {
                label: { airTightness: "2.5 ACH50 (New Const.)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 2.5,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 3.98, //LEEP 0.37/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000113-3"]: {
            label: "2.0 ACH50 (New Const.)",
            packageValues: {
                label: { airTightness: "2.0 ACH50 (New Const.)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 2.0,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 3.98, //LEEP 0.37/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000113-4"]: {
            label: "1.5 ACH50 (New Const.)",
            packageValues: {
                label: { airTightness: "1.5 ACH50 (New Const.)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 1.5,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 3.98, //LEEP 0.37/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000113-5"]: {
            label: "1.0 ACH50 (New Const.)",
            packageValues: {
                label: { airTightness: "1.0 ACH50 (New Const.)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 1.0,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 3.98, //LEEP 0.37/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000113-6"]: {
            label: "0.6 ACH50 (New Const.)",
            packageValues: {
                label: { airTightness: "0.6 ACH50 (New Const.)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 0.6,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 3.98, //LEEP 0.37/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-2025112100000013-3"]: {
            label: "Reduce Air Leakage to 2.5 ACH50 (Retrofit)",
            packageValues: {
                label: { airTightness: "Reduce Air Leakage to 2.5 ACH50 (Retrofit)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 2.5,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 9.47, //LEEP 0.88/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000013-4"]: {
            label: "Reduce Air Leakage to 1.5 ACH50 (Retrofit)",
            packageValues: {
                label: { airTightness: "Reduce Air Leakage to 1.5 ACH50 (Retrofit)" },
                upgradeType: "airTightness",
                upgradeSubType: "airTightness",
                upgradeProcess: "achReplace",
                fields: {
                    testType: {
                        id: 0,
                    },
                    blowerTest: {
                        airChangeRate50Pa: 1.5,
                        eqLeakageArea: 0.75,
                        isCgsbTest: false,
                        isEqLeakageAreaCalculated: true,
                        guarded: false,
                        pressure: {
                            id: null,
                        },
                    },
                    buildingSiteTerrain: {
                        id: 6,
                    },
                    localShieldingWalls: {
                        id: 2,
                    },
                    localShieldingFlue: {
                        id: 1,
                    },
                    exhaustDevicesTest: {
                        id: 0,
                        result: null,
                    },
                    commonSurfaces: {
                        floors: 0,
                        walls: 0,
                        ceilings: 0,
                        total: 0,
                    },
                    other: {
                        weatherStationTerrain: {
                            id: 2,
                        },
                        anemometerHeight: 10,
                        leakageFractions: {
                            useDefaults: true,
                            ceilings: 0,
                            walls: 0,
                            floors: 0,
                        },
                    },
                },
                cost: {
                    airTightness: {
                        total: 0,
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 0,
                                totalArea: 100,
                                pricePerUnit: 9.47, //LEEP 0.88/(sqft*Δ(ACH50)), needs special handling
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    ventilation: {
        ["upgradePre-2025112100000014-0"]: {
            label: "HRV 60% Eff. (New Const.)",
            name: "hrv-SRE60",
            packageValues: {
                label: { ventilation: "HRV 60% Eff. (New Const.)" },
                upgradeType: "ventilation",
                upgradeSubType: "ventilation",
                fields: {
                    manufacturer: "",
                    model: "",
                    supplyFlowrate: 30,
                    exhaustFlowrate: 30,
                    fanPower1: 62.9,
                    fanPower2: 77.4,
                    temperatureCondition1: 0,
                    temperatureCondition2: -25,
                    efficiency1: 60,
                    efficiency2: 50,
                    preheaterCapacity: 0,
                    lowTempVentReduction: 0,
                    coolingEfficiency: 65,
                    isDefaultFanpower: true,
                    isEnergyStar: false,
                    isHVICertified: true,
                    isSupplemental: false,
                    operationSchedule: {},
                    ducts: {
                        supply: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                        exhaust: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                    },
                },
                cost: {
                    ventilation: {
                        total: 3200, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 3200, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000014-1"]: {
            label: "HRV 65% Eff. (New Const.)",
            name: "hrv-SRE65",
            packageValues: {
                label: { ventilation: "HRV 65% Eff. (New Const.)" },
                upgradeType: "ventilation",
                upgradeSubType: "ventilation",
                fields: {
                    manufacturer: "",
                    model: "",
                    supplyFlowrate: 30,
                    exhaustFlowrate: 30,
                    fanPower1: 62.9,
                    fanPower2: 77.4,
                    temperatureCondition1: 0,
                    temperatureCondition2: -25,
                    efficiency1: 65,
                    efficiency2: 60,
                    preheaterCapacity: 0,
                    lowTempVentReduction: 0,
                    coolingEfficiency: 65,
                    isDefaultFanpower: true,
                    isEnergyStar: false,
                    isHVICertified: true,
                    isSupplemental: false,
                    operationSchedule: {},
                    ducts: {
                        supply: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                        exhaust: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                    },
                },
                cost: {
                    ventilation: {
                        total: 3400, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 3400, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000014-2"]: {
            label: "HRV 75% Eff. (New Const.)",
            name: "hrv-SRE75",
            packageValues: {
                label: { ventilation: "HRV 75% Eff. (New Const.)" },
                upgradeType: "ventilation",
                upgradeSubType: "ventilation",
                fields: {
                    manufacturer: "",
                    model: "",
                    supplyFlowrate: 30,
                    exhaustFlowrate: 30,
                    fanPower1: 62.9,
                    fanPower2: 77.4,
                    temperatureCondition1: 0,
                    temperatureCondition2: -25,
                    efficiency1: 75,
                    efficiency2: 69,
                    preheaterCapacity: 0,
                    lowTempVentReduction: 0,
                    coolingEfficiency: 65,
                    isDefaultFanpower: true,
                    isEnergyStar: false,
                    isHVICertified: true,
                    isSupplemental: false,
                    operationSchedule: {},
                    ducts: {
                        supply: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                        exhaust: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                    },
                },
                cost: {
                    ventilation: {
                        total: 3850, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 3850, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000014-3"]: {
            label: "HRV 60% Eff. (Retrofit)",
            name: "hrv-SRE60",
            packageValues: {
                label: { ventilation: "HRV 60% Eff. (Retrofit)" },
                upgradeType: "ventilation",
                upgradeSubType: "ventilation",
                fields: {
                    manufacturer: "",
                    model: "",
                    supplyFlowrate: 30,
                    exhaustFlowrate: 30,
                    fanPower1: 62.9,
                    fanPower2: 77.4,
                    temperatureCondition1: 0,
                    temperatureCondition2: -25,
                    efficiency1: 60,
                    efficiency2: 55,
                    preheaterCapacity: 0,
                    lowTempVentReduction: 0,
                    coolingEfficiency: 65,
                    isDefaultFanpower: true,
                    isEnergyStar: false,
                    isHVICertified: true,
                    isSupplemental: false,
                    operationSchedule: {},
                    ducts: {
                        supply: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                        exhaust: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                    },
                },
                cost: {
                    ventilation: {
                        total: 4400, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 4400, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-2025112100000014-4"]: {
            label: "HRV 78% Eff. (Retrofit)",
            name: "hrv-SRE78",
            packageValues: {
                label: { ventilation: "HRV 78% Eff. (Retrofit)" },
                upgradeType: "ventilation",
                upgradeSubType: "ventilation",
                fields: {
                    manufacturer: "",
                    model: "",
                    supplyFlowrate: 30,
                    exhaustFlowrate: 30,
                    fanPower1: 62.9,
                    fanPower2: 77.4,
                    temperatureCondition1: 0,
                    temperatureCondition2: -25,
                    efficiency1: 78,
                    efficiency2: 72,
                    preheaterCapacity: 0,
                    lowTempVentReduction: 0,
                    coolingEfficiency: 65,
                    isDefaultFanpower: true,
                    isEnergyStar: false,
                    isHVICertified: true,
                    isSupplemental: false,
                    operationSchedule: {},
                    ducts: {
                        supply: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                        exhaust: {
                            length: 1.5,
                            diameter: 152.4,
                            insulation: 0.7,
                            location: {
                                id: 3,
                            },
                            type: {
                                id: 0,
                            },
                            sealing: {
                                id: 1,
                            },
                        },
                    },
                },
                cost: {
                    ventilation: {
                        total: 5150, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 5150, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    heatingCooling: {
        ["upgradePre-202511210000000015-0"]: {
            //["condGasFurnace96eff-AC"]: {
            label: "Condensing Natural Gas Furnace (96%) and AC (New Const.)",
            name: "condGasFurnace96eff-AC",
            packageValues: {
                label: { heatingCooling: "Condensing Natural Gas Furnace (96%) and AC (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            furnace: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                epaCsa: null,
                                isBiEnergy: false,
                                switchoverTemp: 0,
                                energySource: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 5,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 96,
                                    isSteadyState: false,
                                    pilotLight: 0,
                                    flueDiameter: 0,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airConditioning: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    outputCapacity: {
                                        id: 0,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                    coolingEfficiency: {
                                        isCop: false,
                                        value: 14.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 15400, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 15400, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-1"]: {
            //["hybridHeatCondFurnace96eff-ASHP2.5COP"]: {
            label: "Hybrid Heating System: ASHP and Natural Gas Furnace (96%) (New Const.)",
            name: "hybridHeatCondFurnace96eff-ASHP2.5COP",
            allElectric: false,
            packageValues: {
                label: { heatingCooling: "Hybrid Heating System: ASHP and Natural Gas Furnace (96%) (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            furnace: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                epaCsa: null,
                                isBiEnergy: false,
                                switchoverTemp: 0,
                                energySource: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 5,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 96,
                                    isSteadyState: false,
                                    pilotLight: 0,
                                    flueDiameter: 0,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airHeatPump: {
                                manufacturer: "",
                                model: "",
                                ahri: 0,
                                ccashp: false,
                                energyStar: true,
                                crankcaseHeater: 60,
                                function: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 0, //Calculated
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //balance point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 19150, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 19150, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-2"]: {
            //["elec-baseboard+AC"]: {
            label: "Electric Resistance Baseboards and AC (New Const.)",
            name: "elec-baseboard+AC",
            allElectric: true,
            packageValues: {
                label: { heatingCooling: "Electric Resistance Baseboards and AC (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            baseboards: {
                                manufacturer: "",
                                model: "",
                                numElecThermostats: 0,
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 100,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airConditioning: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    outputCapacity: {
                                        id: 0,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                    coolingEfficiency: {
                                        isCop: false,
                                        value: 14.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 13300, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 13300, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-3"]: {
            //["elecHeating-ASHP2.5COP"]: {
            label: "Air Source Heat Pump & Elec. Aux. (New Const.)",
            name: "elecHeating-ASHP2.5COP",
            allElectric: true,
            packageValues: {
                label: { heatingCooling: "Air Source Heat Pump & Elec. Aux. (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            baseboards: {
                                manufacturer: "",
                                model: "",
                                numElecThermostats: 0,
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 100,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airHeatPump: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                numberOfHeads: "1",
                                function: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 0, //Calculated
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //Balance Point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 15550, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 15550, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-4"]: {
            //["elecHeating-CCASHP3.8COP"]: {
            label: "Cold Climate Air Source Heat Pump & Elec. Aux. (New Const.)",
            name: "elecHeating-CCASHP3.8COP",
            allElectric: true,
            packageValues: {
                label: { heatingCooling: "Cold Climate Air Source Heat Pump & Elec. Aux. (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            baseboards: {
                                manufacturer: "",
                                model: "",
                                numElecThermostats: 0,
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 100,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airHeatPump: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                numberOfHeads: "1",
                                function: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 0, //Calculated
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 3.8,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 3.8,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //Balance Point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 20200, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 20200, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-5"]: {
            //["elecHeating-GSHP"]: {
            label: "Ground Source Heat Pump (New Const.)",
            name: "elecHeating-GSHP",
            allElectric: true,
            packageValues: {
                label: { heatingCooling: "Ground Source Heat Pump (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            baseboards: {
                                manufacturer: "",
                                model: "",
                                numElecThermostats: 0,
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 100,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            groundHeatPump: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                canCsaC448: false,
                                crankcaseHeater: 60,
                                numberOfHeads: "1",
                                function: {
                                    id: 1,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 0, //Calculated
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 4.7,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 3,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //Balance Point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                                source: {
                                    depth: 1.5,
                                    use: {
                                        id: 1,
                                    },
                                    temperatures: {},
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 51750, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 51750, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-6"]: {
            //["combo0.8EFTank"]: {
            label: "Combo (non-P9): 0.8 EF Tank with AHU (incl. DHW) (New Const.)",
            name: "combo0.8EFTank",
            packageValues: {
                label: { heatingCooling: "Combo (non-P9): 0.8 EF Tank with AHU (incl. DHW) (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            combo: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                epaCsa: null,
                                energySource: {
                                    id: 0,
                                },
                                equipmentType: {
                                    id: 4,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 90,
                                    isSteadyState: false,
                                    pilotLight: 0,
                                    flueDiameter: 0,
                                    outputCapacity: {
                                        id: 1,
                                        value: 5.5,
                                        uiUnits: "kW",
                                    },
                                    outputCapacity_u: "BTU/h",
                                },
                                tankAndPump: {
                                    tankCapacity: {
                                        id: 3,
                                        value: 189.3,
                                    },
                                    energyFactor: {
                                        useDefaults: true,
                                        value: 0.8,
                                    },
                                    tankLocation: {
                                        id: 0,
                                    },
                                    circulationPump: {
                                        isCalculated: true,
                                        value: 92,
                                        energyEfficientMotor: false,
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airConditioning: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    outputCapacity: {
                                        id: 0,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                    coolingEfficiency: {
                                        isCop: false,
                                        value: 14.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 17250, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 17250, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-7"]: {
            //["p9Combo0.9TPF"]: {
            label: "Combo (P9): 0.9 TPF (incl. DHW system) (New Const.)",
            name: "p9Combo0.9TPF",
            packageValues: {
                label: { heatingCooling: "Combo (P9): 0.9 TPF (incl. DHW system) (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            p9Combo: {
                                manufacturer: "Airmax Technologies",
                                model: "GLOWC95-MAXAIR70E",
                                numberOfSystems: 1,
                                thermalPerformanceFactor: 0.9,
                                annualElectricity: 1800,
                                spaceHeatingCapacity: 12800,
                                spaceHeatingEfficiency: 93,
                                waterHeatingPerformanceFactor: 0.75,
                                burnerInput: 28400,
                                recoveryEfficiency: 89,
                                isUserSpecified: false,
                                testData: {
                                    controlsPower: 14,
                                    circulationPower: 87,
                                    dailyElecUse: 0.5,
                                    standbyLossWithFanOn: 0,
                                    standbyLossWithFanOff: 0,
                                    oneHourRatingHotWater: 447,
                                    oneHourRatingConcurrent: 521,
                                    energySource: {
                                        id: 0,
                                    },
                                    netEfficiency: {
                                        loadPerformance15: 91,
                                        loadPerformance40: 94,
                                        loadPerformance100: 92,
                                    },
                                    electricalUse: {
                                        loadPerformance15: 155,
                                        loadPerformance40: 278,
                                        loadPerformance100: 710,
                                    },
                                    blowerPower: {
                                        loadPerformance15: 160,
                                        loadPerformance40: 162,
                                        loadPerformance100: 568,
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airConditioning: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    outputCapacity: {
                                        id: 0,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                    coolingEfficiency: {
                                        isCop: false,
                                        value: 14.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 19900, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 19900, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        //Not included because it relies on a pseudo-combo being set up (boiler + Tankless HW)
        // ["upgradePre-202511210000000015-8"]: {
        //     //["combo0.95EFTankless"]: {
        //     label: "Combo (non-P9): 0.95 EF Tankless with AHU (incl. DHW system) (New Const.)",
        //     name: "combo0.95EFTankless",
        //     packageValues: {
        //         label: {
        //             heatingCooling: "Combo (non-P9): 0.95 EF Tankless with AHU (incl. DHW system) (New Const.)",
        //         },
        //         upgradeType: "heatingCooling",
        //         upgradeSubType: "heatingCooling",
        //         fields: {
        //             heating: {
        //                 system: {
        //                     boiler: {
        //                         manufacturer: "",
        //                         model: "",
        //                         energyStar: false,
        //                         epaCsa: null,
        //                         isBiEnergy: false,
        //                         switchoverTemp: 0,
        //                         energySource: {
        //                             id: 1,
        //                         },
        //                         equipmentType: {
        //                             id: 5,
        //                         },
        //                         specifications: {
        //                             sizingFactor: 1,
        //                             efficiency: 95,
        //                             isSteadyState: false,
        //                             pilotLight: 0,
        //                             flueDiameter: 0,
        //                             outputCapacity: {
        //                                 id: 1,
        //                                 value: 5.5,
        //                                 uiUnits: "kW",
        //                             },
        //                             outputCapacity_u: "BTU/h",
        //                         },
        //                     },
        //                 },
        //                 fansAndPumps: {
        //                     hasEnergyEfficientMotor: true,
        //                     mode: {
        //                         id: 1,
        //                     },
        //                     power: {
        //                         isCalculated: true,
        //                         low: 0,
        //                         high: 0,
        //                     },
        //                 },
        //             },
        //             cooling: {
        //                 shadingInF280Cooling: "AccountedFor",
        //                 season: {
        //                     start: {
        //                         id: 0,
        //                     },
        //                     end: {
        //                         id: 11,
        //                     },
        //                     design: {
        //                         id: 6,
        //                     },
        //                 },
        //                 fansAndPumps: {
        //                     flowRate: 0,
        //                     hasEnergyEfficientMotor: false,
        //                     mode: {
        //                         id: 0,
        //                     },
        //                     power: {
        //                         isCalculated: true,
        //                         value: null,
        //                     },
        //                 },
        //                 system: {
        //                     airConditioning: {
        //                         manufacturer: "",
        //                         model: "",
        //                         energyStar: false,
        //                         crankcaseHeater: 60,
        //                         equipmentType: {
        //                             id: 0,
        //                         },
        //                         specifications: {
        //                             sizingFactor: 1,
        //                             outputCapacity: {
        //                                 id: 0,
        //                                 value: 0,
        //                                 uiUnits: "kW",
        //                             },
        //                             coolingEfficiency: {
        //                                 isCop: false,
        //                                 value: 14.5,
        //                             },
        //                             coolingParams: {
        //                                 sensibleHeatRatio: 0.76,
        //                                 openableWindowArea: 4,
        //                             },
        //                         },
        //                     },
        //                 },
        //             },
        //             additionalOpenings: {},
        //             multipleSystems: {},
        //             radiantHeating: {},
        //             supplSystems: {},
        //         },
        //         cost: {
        //             heatingCooling: {
        //                 total: 18000, //LEEP /# of families (units),
        //                 items: {
        //                     "item-builtin-cost-1": {
        //                         label: "overallCost",
        //                         total: 18000, //LEEP /# of families (units)
        //                     },
        //                 },
        //             },
        //         },
        //         leepCostEstimate: true,
        //     },
        //     pseudoCombo: true,
        //     additionalValues: {
        //         domesticHotWater: {
        //             primarySystem: {
        //                 manufacturer: "",
        //                 model: "",
        //                 energyStar: false,
        //                 ecoEnergy: false,
        //                 hasDrainWaterHeatRecovery: true,
        //                 insulatingBlanket: 0,
        //                 combinedFlue: false,
        //                 flueDiameter: 0,
        //                 userDefinedPilot: false,
        //                 pilotEnergy: 0,
        //                 connectedUnitsDwhr: 0,
        //                 fractionOfTank: null,
        //                 heatPumpCOP: null,
        //                 energySource: {
        //                     id: 1,
        //                 },
        //                 tankType: {
        //                     id: 10,
        //                 },
        //                 tankVolume: {
        //                     id: 6,
        //                     value: 0,
        //                 },
        //                 energyFactor: {
        //                     id: 1,
        //                     value: 0.95,
        //                 },
        //                 isUniform: false,
        //                 standby: {
        //                     inputCapacity: 11999.8,
        //                     standbyHeatLoss: null,
        //                     standbyHeatLossMode: null,
        //                     thermalEfficiency: null,
        //                 },
        //                 drawPattern: {
        //                     id: null,
        //                 },
        //                 tankLocation: {
        //                     id: 0,
        //                 },
        //                 solar: {},
        //                 drainWaterHeatRecovery: {
        //                     manufacturer: "Power-Pipe",
        //                     model: "C4-57",
        //                     showerLength: 4.5,
        //                     dailyShowers: 3,
        //                     preheatShowerTank: false,
        //                     efficiencyRating: 41.5,
        //                     efficiency: {
        //                         id: 0,
        //                     },
        //                     showerTemperature: {
        //                         id: 0,
        //                     },
        //                     showerHeadFlow: {
        //                         id: 0,
        //                     },
        //                 },
        //             },
        //             secondarySystem: {},
        //             murb: {},
        //         },
        //     },
        // },
        ["upgradePre-202511210000000015-9"]: {
            //["p9Combo0.96TPF"]: {
            label: "Combo (P9): 0.96 TPF (incl. DHW system) (New Const.)",
            name: "p9Combo0.96TPF",
            packageValues: {
                label: { heatingCooling: "Combo (P9): 0.96 TPF (incl. DHW system) (New Const.)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            p9Combo: {
                                manufacturer: "Redzone Products Inc.",
                                model: "17-05-17RZ001",
                                numberOfSystems: 1,
                                thermalPerformanceFactor: 0.96,
                                annualElectricity: 1000,
                                spaceHeatingCapacity: 10600,
                                spaceHeatingEfficiency: 97,
                                waterHeatingPerformanceFactor: 0.93,
                                burnerInput: 46930.07,
                                recoveryEfficiency: 93.3,
                                isUserSpecified: false,
                                testData: {
                                    controlsPower: 10,
                                    circulationPower: 32,
                                    dailyElecUse: 0.26,
                                    standbyLossWithFanOn: 0,
                                    standbyLossWithFanOff: 0,
                                    oneHourRatingHotWater: 1072,
                                    oneHourRatingConcurrent: 1043,
                                    energySource: {
                                        id: 0,
                                    },
                                    netEfficiency: {
                                        loadPerformance15: 96,
                                        loadPerformance40: 99,
                                        loadPerformance100: 90,
                                    },
                                    electricalUse: {
                                        loadPerformance15: 71,
                                        loadPerformance40: 179,
                                        loadPerformance100: 338,
                                    },
                                    blowerPower: {
                                        loadPerformance15: 50,
                                        loadPerformance40: 111,
                                        loadPerformance100: 225,
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airConditioning: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    outputCapacity: {
                                        id: 0,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                    coolingEfficiency: {
                                        isCop: false,
                                        value: 14.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 20050, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 20050, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-202511210000000015-10"]: {
            label: "Condensing Natural Gas Furnace (95% Eff.), no AC (Retrofit)",
            name: "condGasFurnace-95eff",
            packageValues: {
                label: { heatingCooling: "Condensing Natural Gas Furnace (95% Eff.), no AC (Retrofit)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            furnace: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                epaCsa: null,
                                isBiEnergy: false,
                                switchoverTemp: 0,
                                energySource: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 5,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 95,
                                    isSteadyState: false,
                                    pilotLight: 0,
                                    flueDiameter: 0,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {},
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 9550, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 9550, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-11"]: {
            label: "Hybrid Heating: ASHP (2.5 COP) and Existing Gas Furnace (Retrofit)",
            name: "hybridHeatExFurnace-ASHP2.5COP",
            packageValues: {
                label: { heatingCooling: "Hybrid Heating: ASHP (2.5 COP) and Existing Gas Furnace (Retrofit)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {},
                        fansAndPumps: {
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airHeatPump: {
                                manufacturer: "",
                                model: "",
                                ahri: 0,
                                ccashp: false,
                                energyStar: true,
                                crankcaseHeater: 60,
                                function: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 2,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 2, //1.25 x cooling load
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 0,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //balance point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 13450, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 13450, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-12"]: {
            label: "Hybrid Heating: ASHP (2.5 COP) and New Condensing Gas Furnace (Retrofit)",
            name: "hybridHeatCondFurnace-ASHP2.5COP",
            packageValues: {
                label: { heatingCooling: "Hybrid Heating: ASHP (2.5 COP) and New Condensing Gas Furnace (Retrofit)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            furnace: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                epaCsa: null,
                                isBiEnergy: false,
                                switchoverTemp: 0,
                                energySource: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 5,
                                },
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 95,
                                    isSteadyState: false,
                                    pilotLight: 0,
                                    flueDiameter: 0,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airHeatPump: {
                                manufacturer: "",
                                model: "",
                                ahri: 0,
                                ccashp: false,
                                energyStar: true,
                                crankcaseHeater: 60,
                                function: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 2,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 2, //1.25 x cooling load
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 0,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //balance point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 19600, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 19600, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-13"]: {
            label: "ASHP (2.5 COP) & Elec. Aux. (Retrofit)",
            name: "elecHeating-ASHP2.5COP",
            packageValues: {
                label: { heatingCooling: "ASHP (2.5 COP) & Elec. Aux. (Retrofit)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            baseboards: {
                                manufacturer: "",
                                model: "",
                                numElecThermostats: 0,
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 100,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airHeatPump: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                numberOfHeads: "1",
                                function: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 0, //Calculated
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 2.5,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //Balance Point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 19600, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 19600, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000015-14"]: {
            label: "Cold Climate Air Source Heat Pump & Elec. Aux. (Retrofit)",
            name: "elecHeating-CCASHP3.8COP",
            packageValues: {
                label: { heatingCooling: "Cold Climate Air Source Heat Pump & Elec. Aux. (Retrofit)" },
                upgradeType: "heatingCooling",
                upgradeSubType: "heatingCooling",
                fields: {
                    heating: {
                        system: {
                            baseboards: {
                                manufacturer: "",
                                model: "",
                                numElecThermostats: 0,
                                specifications: {
                                    sizingFactor: 1,
                                    efficiency: 100,
                                    outputCapacity: {
                                        id: 1,
                                        value: 0,
                                        uiUnits: "kW",
                                    },
                                },
                            },
                        },
                        fansAndPumps: {
                            hasEnergyEfficientMotor: true,
                            mode: {
                                id: 1,
                            },
                            power: {
                                isCalculated: true,
                                low: 0,
                                high: 0,
                            },
                        },
                    },
                    cooling: {
                        shadingInF280Cooling: "AccountedFor",
                        season: {
                            start: {
                                id: 0,
                            },
                            end: {
                                id: 11,
                            },
                            design: {
                                id: 6,
                            },
                        },
                        fansAndPumps: {
                            flowRate: 0,
                            hasEnergyEfficientMotor: false,
                            mode: {
                                id: 0,
                            },
                            power: {
                                isCalculated: true,
                                value: null,
                            },
                        },
                        system: {
                            airHeatPump: {
                                manufacturer: "",
                                model: "",
                                energyStar: false,
                                crankcaseHeater: 60,
                                numberOfHeads: "1",
                                function: {
                                    id: 1,
                                },
                                equipmentType: {
                                    id: 0,
                                },
                                specifications: {
                                    outputCapacity: {
                                        id: 0, //Calculated
                                        value: 7,
                                        uiUnits: "kW",
                                    },
                                    heatingEfficiency: {
                                        isCop: true,
                                        value: 3.8,
                                    },
                                    coolingEfficiency: {
                                        isCop: true,
                                        value: 3.8,
                                    },
                                    coolingParams: {
                                        sensibleHeatRatio: 0.76,
                                        openableWindowArea: 4,
                                    },
                                },
                                temperature: {
                                    cutoffType: {
                                        id: 0, //Balance Point
                                    },
                                    ratingType: {
                                        id: 0,
                                        value: 8.3,
                                    },
                                },
                            },
                        },
                    },
                    additionalOpenings: {},
                    multipleSystems: {},
                    radiantHeating: {},
                    supplSystems: {},
                },
                cost: {
                    heatingCooling: {
                        total: 24650, //LEEP /# of families (units),
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 24650, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    spaceHeating: {},
    secondaryHeating: {},
    spaceCooling: {},
    primaryHotWater: {
        ["upgradePre-202511210000000019-0"]: {
            label: "0.67 EF Natural Gas Powervent Tank (New Const.)",
            name: "dhwGasStorage-EF0.67",
            packageValues: {
                label: { primaryHotWater: "0.67 EF Natural Gas Powervent Tank (New Const.)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 76.2,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: null,
                        energySource: {
                            id: 1,
                        },
                        tankType: {
                            id: 6,
                        },
                        tankVolume: {
                            id: 3,
                            value: 189.3,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.67,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 2400, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 2400, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000019-1"]: {
            label: "0.80 EF Natural Gas Condensing Tank (New Const.)",
            name: "dhwGasStorage-EF0.80",
            packageValues: {
                label: { primaryHotWater: "0.80 EF Natural Gas Condensing Tank (New Const.)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 76.2,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: null,
                        energySource: {
                            id: 1,
                        },
                        tankType: {
                            id: 16,
                        },
                        tankVolume: {
                            id: 3,
                            value: 189.3,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.8,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 3600, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 3600, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000019-2"]: {
            label: "0.95 EF Natural Gas Tankless (New Const.)",
            name: "dhwGasInst-EF0.95",
            packageValues: {
                label: { primaryHotWater: "0.95 EF Natural Gas Tankless (New Const.)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 0,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: null,
                        energySource: {
                            id: 1,
                        },
                        tankType: {
                            id: 9,
                        },
                        tankVolume: {
                            id: 6,
                            value: 0,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.95,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 3650, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 3650, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000019-3"]: {
            label: "0.92 EF Electric Tank (New Const.)",
            name: "dhwElecStorage-EF0.92",
            packageValues: {
                label: { primaryHotWater: "0.92 EF Electric Tank (New Const.)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 0,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: null,
                        energySource: {
                            id: 0,
                        },
                        tankType: {
                            id: 0,
                        },
                        tankVolume: {
                            id: 3,
                            value: 189.3,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.92,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 1750, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 1750, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000019-4"]: {
            label: "3.5 EF Heat Pump Water Heater (New Const.)",
            name: "dhwHPWH-EF3.5",
            packageValues: {
                label: { primaryHotWater: "3.5 EF Heat Pump Water Heater (New Const.)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 0,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: 3.89,
                        energySource: {
                            id: 0,
                        },
                        tankType: {
                            id: 5,
                        },
                        tankVolume: {
                            id: 3,
                            value: 189.3,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.9,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 4100, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 4100, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },

        ["upgradePre-202511210000000019-5"]: {
            label: "0.67 EF Natural Gas Powervent Tank (Retrofit)",
            name: "dhwGasStorage-EF0.67",
            packageValues: {
                label: { primaryHotWater: "0.67 EF Natural Gas Powervent Tank (Retrofit)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 76.2,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: null,
                        energySource: {
                            id: 1,
                        },
                        tankType: {
                            id: 6,
                        },
                        tankVolume: {
                            id: 3,
                            value: 189.3,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.67,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 3150, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 3150, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000019-6"]: {
            label: "0.94 EF Natural Gas Tankless (Retrofit)",
            name: "dhwGasInst-EF0.94",
            packageValues: {
                label: { primaryHotWater: "0.94 EF Natural Gas Tankless (Retrofit)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 0,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: null,
                        energySource: {
                            id: 1,
                        },
                        tankType: {
                            id: 9,
                        },
                        tankVolume: {
                            id: 6,
                            value: 0,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.94,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 3650, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 3650, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000019-7"]: {
            label: "0.92 EF Electric Storage Tank (Retrofit)",
            name: "dhwElecStorage-EF0.92",
            packageValues: {
                label: { primaryHotWater: "0.92 EF Electric Storage Tank (Retrofit)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 0,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: null,
                        energySource: {
                            id: 0,
                        },
                        tankType: {
                            id: 0,
                        },
                        tankVolume: {
                            id: 3,
                            value: 189.3,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.92,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 2700, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 2700, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000019-8"]: {
            label: "3.5 EF Heat Pump Water Heater (Retrofit)",
            name: "dhwHPWH-EF3.5",
            packageValues: {
                label: { primaryHotWater: "3.5 EF Heat Pump Water Heater (Retrofit)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "primaryHotWater",
                fields: {
                    primarySystem: {
                        manufacturer: "",
                        model: "",
                        energyStar: false,
                        ecoEnergy: false,
                        hasDrainWaterHeatRecovery: false,
                        insulatingBlanket: 0,
                        combinedFlue: false,
                        flueDiameter: 0,
                        userDefinedPilot: false,
                        pilotEnergy: 0,
                        connectedUnitsDwhr: 0,
                        fractionOfTank: null,
                        heatPumpCOP: 3.89,
                        energySource: {
                            id: 0,
                        },
                        tankType: {
                            id: 5,
                        },
                        tankVolume: {
                            id: 3,
                            value: 189.3,
                        },
                        energyFactor: {
                            id: 1,
                            value: 0.9,
                        },
                        isUniform: false,
                        standby: {
                            inputCapacity: 0,
                            standbyHeatLoss: 0,
                            standbyHeatLossMode: 0,
                            thermalEfficiency: 0,
                        },
                        drawPattern: {
                            id: null,
                        },
                        tankLocation: {
                            id: 0,
                        },
                        solar: {},
                        drainWaterHeatRecovery: {},
                    },
                    secondarySystem: {},
                },
                cost: {
                    primaryHotWater: {
                        total: 4750, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 4750, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    dwhr: {
        ["upgradePre-202511210000000020-0"]: {
            label: "DWHR unit, 42% Eff. (New Const.)",
            name: "dwhr-42eff",
            packageValues: {
                label: { dwhr: "DWHR unit, 42% Eff. (New Const.)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "dwhr",
                fields: {
                    manufacturer: "Power-Pipe",
                    model: "C4-57",
                    showerLength: 4.5,
                    dailyShowers: 3,
                    preheatShowerTank: false,
                    efficiencyRating: 41.5,
                    efficiency: {
                        id: 0,
                    },
                    showerTemperature: {
                        id: 0,
                    },
                    showerHeadFlow: {
                        id: 0,
                    },
                },
                cost: {
                    dwhr: {
                        total: 700, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 700, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000020-1"]: {
            label: "DWHR unit, 55% Eff. (New Const.)",
            name: "dwhr-55eff",
            packageValues: {
                label: { dwhr: "DWHR unit, 55% Eff. (New Const.)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "dwhr",
                fields: {
                    dailyShowers: 3,
                    efficiency: { id: 0 },
                    efficiencyRating: 55.3,
                    manufacturer: "Power-Pipe",
                    model: "R2-82",
                    preheatShowerTank: false,
                    showerHeadFlow: { id: 0 },
                    showerLength: 6.5,
                    showerTemperature: { id: 0 },
                },
                cost: {
                    dwhr: {
                        total: 900, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 900, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
        ["upgradePre-202511210000000020-2"]: {
            label: "DWHR unit, 55% Eff. (Retrofit)",
            name: "dwhr-55eff",
            packageValues: {
                label: { dwhr: "DWHR unit, 55% Eff. (Retrofit)" },
                upgradeType: "domesticHotWater",
                upgradeSubType: "dwhr",
                fields: {
                    dailyShowers: 3,
                    efficiency: { id: 0 },
                    efficiencyRating: 55.3,
                    manufacturer: "Power-Pipe",
                    model: "R2-82",
                    preheatShowerTank: false,
                    showerHeadFlow: { id: 0 },
                    showerLength: 6.5,
                    showerTemperature: { id: 0 },
                },
                cost: {
                    dwhr: {
                        total: 1400, //LEEP /# of families (units)
                        items: {
                            "item-builtin-cost-1": {
                                label: "overallCost",
                                total: 1400, //LEEP /# of families (units)
                            },
                        },
                    },
                },
                leepCostEstimate: true,
            },
        },
    },
    generation: {},
    baseLoads: {},
};
